<template>
  <v-app>
    <router-view style="background-color: #0a0a0a; color:#fff;line-height: 1.2; overflow-x: hidden;"/>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
